/**
 * Hiển thị tiền từ minor units (bất biến §0.4: client KHÔNG tính toán tiền, chỉ format).
 * Server là nguồn sự thật; đây chỉ là lớp trình bày (Intl.NumberFormat).
 */
import { formatMoneyMinorIntl, type CurrencyCode } from "@goppy/domain";

export interface FormatMoneyOptions {
  readonly locale?: string;
}

/**
 * Format minor units (vd 150000n VND → "150.000 ₫"). Dùng BigInt → tránh mất chính xác
 * (KHÔNG coerce sang Number: tổng AUM toàn hệ có thể vượt Number.MAX_SAFE_INTEGER, coerce sẽ
 * làm sai chữ số).
 *
 * NOTIF-MONEY-BIGINT (@UC9064): thân hàm (gồm vá mất-dấu-âm US-UI-0283) chuyển nguyên vẹn sang
 * `@goppy/domain` `formatMoneyMinorIntl` để thông báo (api/worker) dùng CHUNG — bản chép riêng của
 * thông báo từng đưa `Number(major)` vào Intl ⇒ lệch chữ số > 2^53. ui-kit giữ chữ ký + locale mặc định.
 */
export function formatMoney(
  amountMinor: bigint,
  currency: CurrencyCode,
  opts: FormatMoneyOptions = {},
): string {
  return formatMoneyMinorIntl(amountMinor, currency, opts.locale ?? "vi-VN");
}
